import {usePage} from '@inertiajs/vue3';
import axios from 'axios';
import Cookies from 'js-cookie';

let page = null;

const __usePage = () => {
  if (!page) {
    page = usePage();
  }
};

const translate = (key) => {
  __usePage();

  const translations = page.props.translations;
  if (translations[key]) {
    return translations[key];
  }

  return key;
};

const _getOrCreateGoogleAnalyticsSessionId = () => {
  const SESSION_KEY = 'google_analytics_session_id';
  let sessionId = sessionStorage.getItem(SESSION_KEY);

  if (!sessionId) {
    sessionId = `${Date.now()}-${Math.floor(Math.random() * 1e6)}`;
    sessionStorage.setItem(SESSION_KEY, sessionId);
  }

  return sessionId;
};

const _fingerprint = () => {
  __usePage();
  const apiKey = page.props.fingerprintApiKey;
  const isPreview = page.props.isPreview;

  if (!apiKey || isPreview) {
    return null;
  }

  const config = window.location.hostname.includes('surveyworld')
      ? {
        endpoint: 'https://cdn2.surveyworld.me',
        scriptUrlPattern: 'https://cdn2.surveyworld.me/web/v<version>/<apiKey>/loader_v<loaderVersion>.js',
      }
      : {};

  return import('https://fpjscdn.net/v3/' + apiKey)
    .then(FingerprintJS => FingerprintJS.load(config));
};

const _registerVisit = (adUrl, callback = null) => {
  const urlParams = new URLSearchParams(window.location.search);

  let fParam = urlParams.get('f');
  if (!fParam) {
    const f = Cookies.get('f');
    if (f) {

      const parsed = JSON.parse(f);

      fParam = parsed[adUrl] ?? null;
    }
  }

  const params = {
    adUrl: adUrl,

    f: fParam,
    et: urlParams.get('et'),
    gclid: urlParams.get('gclid'),
    ga: Cookies.get('_ga'),
    gasid: _getOrCreateGoogleAnalyticsSessionId(),
    fbc: Cookies.get('_fbc') ?? urlParams.get('fbclid'),
    fbp: Cookies.get('_fbp'),
    fid: urlParams.get('fid'),
    ttclid: urlParams.get('ttclid'),
    ttcid: urlParams.get('ttcid'),
    fplacement: urlParams.get('fplacement'),
    ttplacement: urlParams.get('ttplacement'),
    url: window.location.href,
  };

  return axios.get(route('zazu.v1.visit', params))
    .then(response => {
      const date = new Date();
      // 30 days from now
      date.setTime(date.getTime() + (30 * 24 * 60 * 60 * 1000));
      let f = Cookies.get('f');

      const parsed = f ? JSON.parse(f) : {};
      parsed[adUrl] = response.data.visit_key;

      Cookies.set('f', JSON.stringify(parsed), { expires: date });

      if (callback) {
        callback(response.data);
      }
    });
};

const _clickoutParameters = () => {
  return {
    ga: Cookies.get('_ga'),
    gasid: _getOrCreateGoogleAnalyticsSessionId(),
    fbc: Cookies.get('_fbc'),
    fbp: Cookies.get('_fbp'),
  };
};

const _checkIfTargetingCookiesAreAccepted = (callback) => {
  if (window.CookieScript) {
    const result = window.CookieScript.instance.currentState();

    if (
      result.action === 'accept'
      && result.categories.includes('targeting')
    ) {
      callback();
    }
  }
};

const _isPreview = () => {
  __usePage();
  return page.props.isPreview;
};

const _pageBackUrl = (template) => {
  __usePage();

  if (isPreview()) {
    return route('timon.collector-flows.template-preview.index', {
      template: template,
      collectorFlow: page.props.collectorFlowUuid,
      config: page.props.config,
    });
  }

  const adUrlUuid = page.props.adUrlUuid;

  return route('timon.landing.lander', {
    adUrl: adUrlUuid,
  });
};

const _pageUrl = (template, pageName) => {
  __usePage();

  if (isPreview()) {
    return route('timon.collector-flows.template-preview.pages.show', {
      collectorFlow: page.props.collectorFlowUuid,
      page: pageName,
      template: template,
      config: page.props.config,
    });
  }

  const adUrlUuid = page.props.adUrlUuid;

  return route('timon.landing.pages.show', {
    adUrl: adUrlUuid,
    page: pageName,
  });
};

export function __(key) {
  return translate(key);
}

export function fingerprint() {
  return _fingerprint();
}

export function registerVisit(adUrl, callback) {
  return _registerVisit(adUrl, callback);
}

export function clickoutParameters() {
  return _clickoutParameters();
}

export function getOrCreateGoogleAnalyticsSessionId() {
  return _getOrCreateGoogleAnalyticsSessionId();
}

export function checkIfTargetingCookiesAreAccepted(callback) {
  return _checkIfTargetingCookiesAreAccepted(callback);
}

export function isPreview() {
  return _isPreview();
}

export function pageBackUrl(template) {
  return _pageBackUrl(template);
}

export function pageUrl(template, pageName) {
  return _pageUrl(template, pageName);
}

export default {
  methods: {
    __(key) {
      return translate(key);
    },

    fingerprint() {
      return _fingerprint();
    },

    registerVisit(adUrl, callback) {
      return _registerVisit(adUrl, callback);
    },

    clickoutParameters() {
      return _clickoutParameters();
    },

    getOrCreateGoogleAnalyticsSessionId() {
      return _getOrCreateGoogleAnalyticsSessionId();
    },

    checkIfTargetingCookiesAreAccepted(callback) {
      return _checkIfTargetingCookiesAreAccepted(callback);
    },

    isPreview() {
      return _isPreview();
    },

    pageBackUrl(template) {
      return _pageBackUrl(template);
    },

    pageUrl(template, pageName) {
      return _pageUrl(template, pageName);
    },
  },
};
